import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import { reactive, toRefs, watch } from 'vue';
import apis from "@/api";
export default {
  props: {
    show: Boolean
  },
  emits: ['update:show', 'chooseHandler'],
  setup(props, {
    emit
  }) {
    let data = reactive({
      query: {
        pageNo: 1,
        pageSize: 50
      },
      tagsList: [],
      total: 0
    });
    const fetchData = () => {
      apis.queryTagByParNum(data.query).then(res => {
        if (res.success) {
          // ctx.emit("update:modelValue", res.data);
          data.tagsList = res.data.records;
          data.total = res.data.total;
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    const onSubmit = () => {
      fetchData();
    };
    watch(() => props.show, () => {
      fetchData();
    }, {
      immediate: true
    });
    watch(() => data.query.pageNo, () => {
      fetchData();
    });
    const chooseHandler = item => {
      emit('chooseHandler', item);
      // emit('update:show', false)
    };
    return {
      ...toRefs(data),
      onSubmit,
      chooseHandler
    };
  }
};